// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MZWG","largestCol":"styles_largestCol__e9OZJ","smallestCol":"styles_smallestCol__1kOkR"};